var _circle, _circle2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAutomatedCircleIcon = function SvgAutomatedCircleIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "url(#paint0_linear_12261_19171)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 13,
    fill: "url(#paint1_linear_12261_19171)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0172 11.7071L12.4961 13.7148C11.4383 14.5571 10.9095 14.9783 11.0127 15.4485L11.0182 15.4718C11.1358 15.9391 11.8062 16.1187 13.147 16.4781C13.892 16.6776 14.2646 16.7775 14.4394 17.0598L14.4483 17.0747C14.6169 17.3605 14.521 17.7185 14.3292 18.4344L14.279 18.6214C13.7471 20.6062 13.4813 21.5985 13.9934 21.919C14.5055 22.2395 15.3203 21.5906 16.9499 20.2929L19.4711 18.2852C20.5288 17.443 21.0577 17.0218 20.9545 16.5515L20.9491 16.5282C20.8314 16.0609 20.161 15.8813 18.8203 15.5221C18.0752 15.3224 17.7026 15.2225 17.5279 14.9402L17.519 14.9253C17.3503 14.6395 17.4463 14.2816 17.6381 13.5658L17.6882 13.3786C18.22 11.3938 18.486 10.4015 17.9738 10.081C17.4617 9.7605 16.6468 10.4094 15.0172 11.7071Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0172 11.7071L12.4961 13.7148C11.4383 14.5571 10.9095 14.9783 11.0127 15.4485L11.0182 15.4718C11.1358 15.9391 11.8062 16.1187 13.147 16.4781C13.892 16.6776 14.2646 16.7775 14.4394 17.0598L14.4483 17.0747C14.6169 17.3605 14.521 17.7185 14.3292 18.4344L14.279 18.6214C13.7471 20.6062 13.4813 21.5985 13.9934 21.919C14.5055 22.2395 15.3203 21.5906 16.9499 20.2929L19.4711 18.2852C20.5288 17.443 21.0577 17.0218 20.9545 16.5515L20.9491 16.5282C20.8314 16.0609 20.161 15.8813 18.8203 15.5221C18.0752 15.3224 17.7026 15.2225 17.5279 14.9402L17.519 14.9253C17.3503 14.6395 17.4463 14.2816 17.6381 13.5658L17.6882 13.3786C18.22 11.3938 18.486 10.4015 17.9738 10.081C17.4617 9.7605 16.6468 10.4094 15.0172 11.7071Z",
    fill: "url(#paint2_linear_12261_19171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12261_19171",
    x1: 28.1625,
    y1: 1.47473,
    x2: 5.69276,
    y2: 23.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7FB8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#5142F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12261_19171",
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12261_19171",
    x1: 19.7719,
    y1: 10.553,
    x2: 9.24967,
    y2: 19.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.389445,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5142F1"
  })))));
};
export default SvgAutomatedCircleIcon;